const newChannel2020Sem3 = () => import('@/views/2020sem/2020sem3.vue');

export default [
  {
    path: '/2020sem3',
    name: '2020sem3',
    component: newChannel2020Sem3
  }
];
